import Footer from "../../component/Footer/Footer";
import { Navbar } from "../../component/Navbar/NavBar";
import { NewsContent } from "./News.content";

export const NewsPage = () => {
  return (
    <div className="d-flex flex-column vh-100">
      <Navbar fixedTop={false} />
      <NewsContent />
      <Footer />
    </div>
  );
};